export const ADD_ALL_CLIENTS = "ADD_ALL_CLIENTS";
export const REMOVE_ALL_CLIENTS = "REMOVE_ALL_CLIENTS";
export const EDIT_CLIENT_BY_INDEX = "EDIT_CLIENT_BY_INDEX";
export const REMOVE_CLIENT_BY_INDEX = "REMOVE_CLIENT_BY_INDEX";
